import React from "react";
import './NoContent.scss';

const NoContent = ({message=null}) => (
	<div className="no-content">
        <span>{message || 'No data available'}</span>
	</div>
);

export default NoContent;